import { message } from "antd";
import http from "./http"

export interface IData<T>{
	code:number,
	msg:string,
	data:T,
	[key:string]:any
}

class Base{
	protected baseUrl:string;
	//网络错误是否提示
	protected netBool:boolean;
	protected res={
		'code':300,
		'msg':'网络出错,请重试'
	}
	constructor(_url:string){
		this.baseUrl = _url
		this.netBool = false
	}
	//不单独处理网络问题
	protected NetErr(msg:string=this.res.msg){
		if(this.netBool){
			message.error(msg)
		}
		return;
	}

	protected async HttpGet<T, Y>(url:string,data:T|undefined):Promise<IData<Y>>{
		try {
			return await http.Get(this.baseUrl+url,data)
		} catch (error) {
			this.NetErr()
			return error as IData<Y>;
		}
	}

	protected async HttpDel<T, Y>(url:string,data:T):Promise<IData<Y>>{
		try {
			return await http.Del(this.baseUrl+url, data)
		} catch (error) {
			this.NetErr()
			return error as IData<Y>;
		}
	}

	protected async HttpPost<T, Y>(url:string,data:T):Promise<IData<Y>>{
		try {
			return await http.Post(this.baseUrl+url,data)
		} catch (error) {
			this.NetErr()
			return error as IData<Y>;
		}
	}

	protected async HttpPut<T, Y>(url:string,data:T):Promise<IData<Y>>{
		try {
			return await http.Put(this.baseUrl+url,data)
		} catch (error) {
			this.NetErr()
			return error as IData<Y>;
		}
	}
	
	protected async HttpUpload(data:any,callback:Function){
		return  http.UploadProgress(this.baseUrl+'api/upload',data,callback)
	}
}

export default Base;